module.exports = __webpack_public_path__ + "static/media/1012668.349f0104.jpg";